<template>
  <div>
    <div class="form">
      <div class="form-img">
        <img src="../../assets/images/shop.png" />
      </div>

      <div class="form-box">
        <div class="form-box-t">选择类型</div>
        <div class="form-box-c">
          <formtag @change="getType" :lists="['出租商铺','出售商铺','转让店铺']"></formtag>
        </div>
      </div>
      <div class="form-box">
        <div class="form-box-t">
          您房子的图片
          <small>上传清晰全面的房源图片更容易接到客户的来电哦</small>
        </div>
        <div class="form-box-c" v-if="refer=='wechat'">
           <upload @change="getPictures" />
        </div>
        <div class="form-box-c" v-if="refer=='qianfan'  || refer=='pc'">
          <upload @change="getPictures" />
        </div>
      </div>
      <div class="form-box">
        <div class="form-box-t">选择商圈</div>
        <div class="form-box-c">
          <input
            type="text"
            class="form-input-c"
            placeholder="填写商圈名称（例如：时代广场）"
            v-model="formItem.community"
            :maxlength="8"
          />
        </div>
      </div>
 

      <div class="form-box">
        <div class="form-box-t">装修程度</div>
        <div class="form-box-c">
          <formtag @change="getZhuangxiu" :lists="configs['zhuangxiu']"></formtag>
        </div>
      </div>
      <van-row :gutter="15">
        <van-col :span="12">
          <div class="form-box">
            <div class="form-box-t">建筑面积</div>
            <div class="form-box-c">
              <div class="form-box-tag">
                <div class="form-input-flex">
                  <input type="number" class="form-input" v-model="formItem.mianji" />
                  <div class="unit">m²</div>
                </div>
              </div>
            </div>
          </div>
        </van-col>
        <van-col :span="12">
          <div class="form-box">
            <div class="form-box-t">{{txt}}(0为面议)</div>
            <div class="form-box-c">
              <div class="form-box-tag">
                <div class="form-input-flex">
                  <input type="number" class="form-input" v-model="formItem.price" />
                  <div class="unit">{{formItem.unit}}</div>
                </div>
              </div>
            </div>
          </div>
        </van-col>
      </van-row>
      <div class="form-box">
        <div class="form-box-t">商铺位置属性</div>
        <div class="form-box-c">
          <van-checkbox-group v-model="formItem.tese">
            <van-checkbox
              v-for="(item, index) in ['临街旺铺','住宅底商','商业街商铺','购物中心','人流量大','低价转让']"
              :key="index"
              :name="item"
            >{{ item }}</van-checkbox>
          </van-checkbox-group>
        </div>
      </div>
      <div class="form-box">
        <div class="form-box-t">经营范围（多选）</div>
        <div class="form-box-c">
          <van-checkbox-group v-model="formItem.fanwei">
            <van-checkbox
              v-for="(item, index) in configs['tese1']"
              :key="index"
              :name="item"
            >{{ item }}</van-checkbox>
          </van-checkbox-group>
        </div>
      </div>
      <div class="form-box">
        <div class="form-box-t">联系人</div>
        <div class="form-box-c">
          <div class="form-box-tag">
            <div class="form-input-float">
              <input type="text" v-model="formItem.username" />
            </div>
          </div>
        </div>
      </div>

      <div class="form-box">
        <div class="form-box-t">联系电话</div>
        <div class="form-box-c">
          <div class="form-box-tag">
            <div class="form-input-float">
              <input type="number" v-model="formItem.phone" />
            </div>
          </div>
        </div>
      </div>

      <div class="form-box">
        <div class="form-box-t">房源描述</div>
        <div class="form-box-c">
          <div class="form-box-tag">
            <div class="form-input-float">
              <textarea
                v-model="formItem.content"
                rows="4"
                placeholder="详细的描述商铺情况，可以帮你快速的找到客户（5-2000个字符）"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="form-box">
        <div class="form-box-t">
          <van-button type="info" block @click="post">发布</van-button>
        </div>
      </div>
    </div>
    <footbar></footbar>
  </div>
</template>

<script>
window.addEventListener(
  "message",
  function(event) {
    // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
    var loc = event.data;
    if (loc && loc.module == "locationPicker") {
      //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
      console.log("location", loc);
    }
  },
  false
);
var root = process.env.VUE_APP_API_URL;
import Formtag from "../commpents/tag";
import Selecttime from "../commpents/Selecttime";
import Ruzhu from "../commpents/ruzhu";
import Huxingpicker from "../commpents/huxingpicker";
import Loucengpicker from "../commpents/loucengpicker";
import Upload from "../commpents/upload";
import Footbar from "../commpents/footbar";
import District from "../commpents/district";
import Community from "../commpents/community";
import Wechat from "../commpents/wechat";
import Tencentmap from "../commpents/tencentmap";
import Marea from "../commpents/marea";
import {
  Checkbox,
  CheckboxGroup,
  Card,
  SubmitBar,
  Toast,
  Cell,
  CellGroup,
  Button,
  Tabbar,
  TabbarItem,
  Icon,
  Row,
  Col,
  Tag,
  IndexBar,
  IndexAnchor
} from "vant";

export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    Formtag,
    Selecttime,
    Ruzhu,
    Huxingpicker,
    Loucengpicker,
    Upload,
    Footbar,
    District,
    Community,
    Wechat,
    Tencentmap,
    Marea
  },

  data() {
    return {
      getInitUrl: root + "post/init",
      getPostUrl: root + "post/shop",
      active: "home",
      isactive: false,
      refer: "",
      islogin: 0,
      txt: "出租价格",
      peitao: [
        "电视机",
        "冰箱",
        "洗衣机",
        "空调",
        "热水器",
        "床",
        "暖气",
        "宽带",
        "衣柜",
        "天然气"
      ],
      configs: [],
      formItem: {
        id: 0,
        community: "",
        area: {},
        huxing: [],
        louceng: [],
        mianji: "",
        zhuangxiu: "",
        map: {},
        type: "",
        tese: [],
        fanwei: [],
        price: "",
        pictures: [],
        phone: "",
        username: "",
        title: "出租",
        content: "",
        unit: "元/月"
      }
    };
  },

  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },

  methods: {
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: {},
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          self.configs = reponseData.configs;
          self.formItem.username = reponseData.name;
          self.formItem.phone = reponseData.mobile;
          self.refer = reponseData.refer;
          self.islogin = reponseData.islogin;
          if (self.islogin == 0) {
            self.$router.push("/login");
          }
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    getArea(value) {
      this.formItem.area = value;
    },
    getXiaoqu(value) {
      this.formItem.community = value;
    },
    getChaoxiang(value) {
      this.formItem.chaoxiang = value;
    },
    getLouceng(value) {
      this.formItem.louceng = value;
    },
    getMap(value) {
      this.formItem.map = value;
    },
    getHuxing(value) {
      this.formItem.huxing = value;
    },

    getType(value) {
      this.formItem.type = value;
      if (value == "出租商铺") {
        this.formItem.unit = "元/月";
        this.txt = "出租价格";
      }
      if (value == "出售商铺") {
        this.formItem.unit = "万元";
        this.txt = "出售价格";
      }
      if (value == "转让店铺") {
        this.formItem.unit = "万元";
        this.txt = "转让费";
      }
    },
    getZhuangxiu(value) {
      this.formItem.zhuangxiu = value;
    },
    getPay(value) {
      this.formItem.pay = value;
    },

    getPictures(value) {
      this.formItem.pictures = value;
      console.log(value);
    },
    post() {
      if (this.isactive) {
        this.$toast("已经提交");
        return;
      }
      var self = this;
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: "数据提交中"
      });

      $.ajax({
        url: self.getPostUrl,
        timeout: 120000,
        dataType: "json",
        type: "post",
        data: self.formItem,
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          self.$toast.clear();
          if (reponseData.status == 1) {
            self.isactive = true;
          //  self.$toast(reponseData.message);
             self.$router.push("/post/zhifu/" + reponseData.data[0] + "/shop");
             //self.$router.push("/shop/view/" + reponseData.data[0]);
          } else {
            self.$toast(reponseData.message);
            self.isactive = false;
          }
        },
        error: function() {
          self.$toast("system error");
        }
      });
    }
  }
};
</script>

<style scoped>
#mapPage {
  width: 100vw;
  height: 100vh;
  display: block;
}
.van-checkbox-group {
  display: flex;
  flex-flow: wrap;
  background-color: #f8f8f8;
  padding: 10px 0 10px 15px;
  border-radius: 4px;
}
.van-checkbox {
  width: 33.33333%;
  margin: 5px 0;
}
</style>>



